import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Dijital ve Yapay Zeka Olgunluk Endeksi (DAIMI) — çözüm sayfası, Türkçesi.
 *
 * Bölüm sırası, görseller, maddeler ve sayılar İngilizcesiyle birebir aynı;
 * değişen yalnızca nasıl söylendiği. Ürün adları ve yerleşik terimler İngilizce
 * kalıyor — DAIMI, Impact Platform, benchmark, roadmap, scorecard, CaaS,
 * Vitality ve Snowflake Analysis, quarterly business review.
 *
 * Müşteri sözleri çevrilmiyor: alıntı, söylendiği dilde durur.
 *
 * Açık sorular (video, eksik üç logo, kapanıştaki form) İngilizce dosyada ve
 * orada bir kez duruyor — aynı karar iki dilde iki not olarak sayılmasın.
 */
/** "Ücretsiz deneyin" artık Impact Platform'a gidiyor — İngilizcesiyle aynı. */
const TASTER = 'https://impact.digitopia.ai'
const COURSE = '/en/digital-ai-maturity-index-daimi-course'
const REPORT = '/en/impact-labs/reports/digital-ai-maturity-report-2026'
const PLATFORM = 'https://impact.digitopia.ai'

export const daimiSolution: WrittenPage = {
  navLabel: 'Dijital ve Yapay Zeka Olgunluk Endeksi',
  title: 'Dijital ve Yapay Zeka Olgunluk Endeksi (DAIMI)',
  description:
    'DAIMI, geleneksel danışmanlığın yapay zeka destekli alternatifi. Dijital ve yapay zeka olgunluğunuzu ölçüyor, yol haritanızı çıkarıyor ve uygulamanıza eşlik ediyoruz: altı boyut, 120’den fazla başlık ve global benchmark, Impact Platform üzerinden.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Dijital ve Yapay Zeka Olgunluk Endeksi (DAIMI)',
      headline: 'İşinizi yapay zekayla büyütün',
      sub: 'Dijital ve yapay zeka olgunluğunuzu ölçüyoruz. Yol haritanızı çıkarıyoruz. Uygulamanıza eşlik ediyoruz.',
      micro: 'Hedeflerinize ulaşın: #transformbetter',
      ctas: [
        // Kapanış formu artık bu sayfanın altında; buton okuru başka sayfaya
        // değil aşağıdaki forma indiriyor (2026-08-30).
        { label: 'Bize Ulaşın', href: '#contact' },
        { label: 'Ücretsiz deneyin', href: TASTER },
      ],
      photo: {
        src: '/photo/boardroom-daimi-recommendations.webp',
        alt: 'Bir danışman, toplantı odasındaki ekranda Impact Platform’un öneri ve yol haritası ekranını anlatıyor.',
      },
    },
    {
      kind: 'logos',
      heading: 'Başarılı şirketler Digitopia ile çalışıyor.',
      items: [
        { name: 'Intel', src: '/logo/intelaicard.png', padded: true },
        { name: 'Microsoft', src: '/logo/microsoft.webp' },
        { name: 'PROVEN', src: '/logo/provencard.png', padded: true },
        { name: 'Sempertex', src: '/logo/sempertex.webp' },
        { name: 'Siemens', src: '/logo/siemens.webp' },
        { name: 'Unilever', src: '/logo/unilever.webp' },
        { name: 'Vodafone', src: '/logo/vodafone.webp' },
      ],
    },
    {
      kind: 'quotes',
      items: [
        {
          quote:
            'Digitopia fundamentally transformed how we view and execute digital transformation. DAIMI gave us quick clarity on where we stood and what to fix first, and the Impact Platform helped us stay aligned, track outcomes, and keep improving.',
          source: 'CIO, Fortune 500 Manufacturing Company',
        },
      ],
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Geleneksel danışmanlığın ötesine geçin.',
      sub: 'DAIMI (Dijital ve Yapay Zeka Olgunluk Endeksi), geleneksel danışmanlığın yapay zeka destekli alternatifi. Slaytlara daha az, karara ve uygulamaya daha çok zaman.',
      body: [
        'DAIMI tek başına bir framework değil. Uzman rehberliğiyle yazılımın ölçeğini bir araya getiren, uçtan uca bir dönüşüm sistemi. Şunları alıyorsunuz:',
      ],
      points: [
        'Hizalanmayı ve kararları yönlendiren bir uzman danışman.',
        'Altı boyutta kanıtlanmış bir olgunluk framework’ü (insan, teknoloji, yönetişim, müşteri, operasyon ve inovasyon).',
        'Performansınızı sektör emsalleri ve liderlerle karşılaştıran global benchmark’lar.',
        'Olgunluk açıklarını önceliklendirilmiş bir roadmap’e çeviren, ekipleri hizada tutan, ilerlemeyi ve sonucu takip eden Impact Platform.',
      ],
      outro: [
        'DAIMI, olgunluk içgörüsünü uygulanabilir bir yol haritasına çevirir; uygulamayı görünür, ölçülebilir ve planında tutar.',
      ],
      photo: {
        src: '/photo/boardroom-daimi-benchmark-review.png',
        alt: 'Bir danışman, toplantı odasındaki ekranda DAIMI skorunu, boyut bazlı skorları ve sektör benchmark’ını anlatıyor.',
      },
      // Film 2026-08-30'da geldi; üstteki fotoğraf poster ve fallback olarak kalıyor.
      video: {
        src: 'https://njdxtkezxgkrmwwhzcne.supabase.co/storage/v1/object/public/website-documents/video/9812a580-68e5-4861-b4c5-8df645f64e1e-DMI_Merged_V3_web_crf23.mp4',
        title: 'DAIMI’ye kısa bir bakış: altı boyutlu olgunluk framework’ü, global benchmark ve Impact Platform içinde dönüştüğü roadmap.',
      },
      ctas: [
        // Kapanış formu artık bu sayfanın altında; buton okuru başka sayfaya
        // değil aşağıdaki forma indiriyor (2026-08-30).
        { label: 'Bize Ulaşın', href: '#contact' },
        { label: 'Ücretsiz deneyin', href: TASTER },
      ],
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: '10 kat avantajınız',
      points: [
        '10x daha hızlı sonuç: Olgunluk endeksinizi aylarla değil saatlerle ölçün. Bitmeyen görüşmeler ve sonuç beklemek yok.',
        '10x daha büyük etki: İlk günden somut iş değeri üreten, veriye dayalı bir hizalanma ve net bir roadmap.',
        '10x daha erişilebilir: Danışmanlığı yazılım olarak sunuyoruz (CaaS). Adam-gün yok, gizli danışmanlık saati yok, bağlayıcı şart yok.',
        '10x daha verimli: Başarınızı ve ilerlemenizi düzinelerce danışmanla değil, verimli ve yapay zeka destekli bir platformla kontrol edin.',
      ],
      photo: {
        src: '/photo/boardroom-daimi-target-state-applause.webp',
        alt: 'Bir yönetim ekibi, mevcut ve hedef DAIMI durumunu gösteren ekranın önünde alkışlıyor.',
      },
      ctas: [
        // Kapanış formu artık bu sayfanın altında; buton okuru başka sayfaya
        // değil aşağıdaki forma indiriyor (2026-08-30).
        { label: 'Bize Ulaşın', href: '#contact' },
        { label: 'Ücretsiz deneyin', href: TASTER },
      ],
    },
    {
      kind: 'prose',
      align: 'center',
      size: 'lg',
      heading: 'Neler dahil?',
      sub: 'Değerlendirme, strateji, uygulama ve sürekli iyileştirme boyunca kurumunuzu destekleyen tek bir çözüm, ekosistem ve platform.',
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'Değerlendirme',
      points: [
        '6 boyut ve 120’den fazla başlıktan oluşan DAIMI framework’ü.',
        'Sertifikalı bir uzmanın modere ettiği, ekiplerinizle 6 workshop.',
        'Sektör benchmark’ını da içeren DAIMI Scorecard.',
        'Durumunuzu derinlemesine anlamanız için Vitality ve Snowflake Analysis.',
        'Üst yönetiminize executive briefing.',
      ],
      photo: {
        src: '/photo/impact-platform-people-session.webp',
        alt: 'Impact Platform’un People oturumu: solda başlık listesi, sağda Agility için mevcut ve hedef skor.',
      },
      ctas: [
        // Kapanış formu artık bu sayfanın altında; buton okuru başka sayfaya
        // değil aşağıdaki forma indiriyor (2026-08-30).
        { label: 'Bize Ulaşın', href: '#contact' },
        { label: 'Ücretsiz deneyin', href: TASTER },
      ],
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Strateji',
      points: [
        'İş hedeflerinizi ve önceliklerinizi belirlemek için workshop’lar ve araçlar.',
        'Yatırımlarınızı, projelerinizi ve roadmap’inizi belirlemek için workshop’lar ve araçlar.',
        'Etkili karar alma için üst yönetiminize executive briefing.',
      ],
      photo: {
        src: '/photo/impact-platform-strategy-projects.webp',
        alt: 'Impact Platform’un Projects ekranı: aciliyet ve öneme göre konumlanmış proje adayları ve yanlarındaki liste.',
      },
      ctas: [
        // Kapanış formu artık bu sayfanın altında; buton okuru başka sayfaya
        // değil aşağıdaki forma indiriyor (2026-08-30).
        { label: 'Bize Ulaşın', href: '#contact' },
        { label: 'Ücretsiz deneyin', href: TASTER },
      ],
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'Uygulama',
      points: [
        'Transformation management office yazılım platformu (yakında)',
        '3 quarterly business review ve kalite güvencesi',
        'Yapay zeka wizard’larıyla sürekli destek (yakında)',
      ],
      photo: {
        src: '/photo/impact-platform-execution-roadmap.webp',
        alt: 'Impact Platform’un Roadmap ekranı: dört çeyreğe yayılmış üç program ve projeleri.',
      },
      ctas: [
        // Kapanış formu artık bu sayfanın altında; buton okuru başka sayfaya
        // değil aşağıdaki forma indiriyor (2026-08-30).
        { label: 'Bize Ulaşın', href: '#contact' },
        { label: 'Ücretsiz deneyin', href: TASTER },
      ],
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Impact Platform',
      body: [
        'DAIMI, olgunluk içgörüsünü ölçülebilir uygulamaya çeviren dönüşüm yönetimi yazılımı Impact Platform üzerinden veriliyor. Tek bir yerde emsallerinizle benchmark yapabilir, bulguları önceliklendirilmiş bir roadmap’e çevirebilir, sahiplik atayabilir, ilerlemeyi ve etkiyi analitik ve yapay zeka destekli rehberlikle takip edebilirsiniz. Böylece dönüşümünüz, geleneksel yaklaşımların gecikmeleri olmadan değerlendirmeden sonuca ilerler.',
      ],
      photo: {
        src: '/photo/impact-platform-daimi-dashboard.webp',
        alt: 'Impact Platform ana ekranı: güncel DAIMI skoru, yıllık ilerleme, milestone’lar ve devam eden boyut çalışmaları.',
      },
      ctas: [{ label: 'Platformu yakından tanıyın', href: PLATFORM }],
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'Digital & AI Maturity Report 2026',
      body: [
        'Yapay zeka benimsenmesi hızlanıyor, ama gerçek yetkinlik geride kalıyor. Altı yıllık araştırmaya ve 20’den fazla ülkede yapılmış 1.300’ü aşkın değerlendirmeye dayanan Digital & AI Maturity Report 2026, liderlerin ihtiyaç duyduğu global gerçeklik kontrolünü sunuyor. 1.575 kurumdan gelen veriyle rapor, “yetkinlik açığını” sayılarla ortaya koyuyor ve varsayımların yerine kararlı adımı koymanız için kanıta dayalı bir kuzey yıldızı veriyor.',
      ],
      photo: {
        src: '/photo/daimi-report-2026-mockup.webp',
        alt: 'Digital & AI Maturity Report 2026’nın iki kopyası, Şubat 2026.',
      },
      ctas: [{ label: 'Raporu indirin', href: REPORT }],
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Uzman olarak sertifikalanın',
      body: [
        'Yoğun ilgi gören, yapılandırılmış ve uzman liderliğindeki kurs, dijital dönüşüm için gereken beceriyi ve pratik bilgiyi geliştirmeniz için tasarlandı. Tanınan bir sertifika kazanın.',
      ],
      photo: {
        src: '/photo/learning-platform-tablet.webp',
        alt: 'Tablet ekranında Digitopia Learning Platform giriş sayfası.',
      },
      ctas: [{ label: 'Öğrenmeye başlayın', href: COURSE }],
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'Doğru bilgiyle önde kalın',
      body: [
        'Bilinçli karar almak ve dönüşüm yolculuğunuzu hızlandırmak için en güncel stratejik rehberlere ulaşın. Özel içgörülerle önde kalın.',
      ],
      photo: {
        src: '/photo/digitopia-report-and-ebook-covers.webp',
        alt: 'Yelpaze gibi dizilmiş beş Digitopia kapağı: Digital & AI Maturity Report 2026, Top 10 Trends 2026 ve üç e-kitap.',
      },
      ctas: [{ label: 'Kaynaklara göz atın', href: LINKS.reports }],
    },
    {
      kind: 'quotes',
      variant: 'fame',
      items: [
        {
          quote:
            'Working with Digitopia has been a transformative experience for PROVEN. The Digital Maturity Index provided the clarity and structure we needed to assess our capabilities, while the interactive sessions delivered valuable, actionable insights. Benchmarking against industry peers gave us clear direction, ensuring smarter investments and stronger alignment across leadership. This initiative has set a solid foundation for our digital transformation, and we’re excited to build on this momentum.',
          source: 'Johann Heaven, CEO, PROVEN',
          company: 'PROVEN',
          logo: { name: 'PROVEN', src: '/logo/provencard.png' },
          portrait: { src: '/photo/portrait-johann-heaven.png', alt: 'Johann Heaven' },
          cta: { label: 'PROVEN’in hikâyesini okuyun', href: '/en/customers/proven' },
        },
        {
          quote:
            'Digitopia’s Digital Maturity Index gave us the clarity about the positive progress we have made recently in creating business value with digitalization. We also had a chance to benchmark ourselves with the industry peers. Digitopia’s insightful recommendations helped us fine tune and confirm our strategy. This partnership has been a key milestone in our journey to innovation and digitalization.',
          source: 'Tekin Gülşen, VP of IT Y-EMEA and Global Applications',
          company: 'Yazaki',
          logo: { name: 'Yazaki', src: '/logo/yazakicard.png' },
          portrait: { src: '/photo/portrait-tekin-gulsen.png', alt: 'Tekin Gülşen' },
          cta: { label: 'Yazaki’nin hikâyesini okuyun', href: '/en/customers/yazaki' },
        },
        {
          quote:
            'Digitopia’s DMI assessments have helped us create clear, actionable digital roadmaps while staying on track. Their insights have been invaluable, guiding us to focus on critical areas like AI long before it became a major topic. As part of Sabancı Holding, it’s a significant advantage that other group companies also use Digitopia’s assessments, enabling a comprehensive view of digital maturity across the group. Digitopia is not just a partner; they play an essential role in shaping and driving our digital strategy.',
          source: 'Fatih Akar, Director of Global Information Technologies',
          company: 'Kordsa',
          logo: { name: 'Kordsa', src: '/logo/kordsacard.png' },
          portrait: { src: '/photo/portrait-fatih-akar.png', alt: 'Fatih Akar' },
          cta: { label: 'Kordsa’nın hikâyesini okuyun', href: '/en/customers/kordsa' },
        },
      ],
      cta: { label: 'Hikâyelerin tamamını okuyun', href: LINKS.hallOfFame },
    },
    // Kapanıştaki siyah CTA bandı kaldırıldı (2026-08-30) — sayfanın altındaki
    // form zaten orada.
  ],
}
